// 一進入網頁時判斷的 function

import {
  watch, computed,
} from 'vue';

import { useRouter, useRoute } from 'vue-router';
import cusStorage from '@/utils/cusStorage';
import { whoamiAPI } from '@/api/members';
import useRequest from '@/hooks/useRequest';
import useMemberLevel from '@/hooks/useMemberLevel';
import { useSiteStore } from '@/store/site';
import { useNewMusicPlayerStore } from '@/store/newMusicPlayer';
// import { useMusicPlayerStore } from '@/store/musicPlayer';

// import useErrorDialog from '@/hooks/useErrorDialog';
import { useCacheStore } from '@/store/cache';

export default () => {
  // const { errorDialog } = useErrorDialog();
  const router = useRouter();
  const route = useRoute();
  const { request: whoamiRequest, response: whoamiResponse } = useRequest(whoamiAPI);
  const cacheStore = useCacheStore();
  const siteStore = useSiteStore();
  // const musicPlayerStore = useMusicPlayerStore();
  const newMusicPlayerStore = useNewMusicPlayerStore();
  const memberInfo = computed(() => siteStore.memberInfo);
  const { memberLevel: currentMemberLevel } = useMemberLevel();

  const originMemberLevel = cusStorage.getItem('memberLevel');

  const handleRoute = () => {
    // 沒有 meta 或者 需要權限 就踢回首頁

    if (route.meta.auth === true) {
      router.push({ name: 'home' });
    }
  };

  watch(currentMemberLevel, (v) => {
    if (v !== originMemberLevel) newMusicPlayerStore.handleClearMusicPlayer();
  });

  const handleAuth = async () => {
    if (Object.keys(memberInfo.value).length > 0) {
      return;
    }

    if (cusStorage.getItem('token') || cusStorage.getItem('token', true)) {
      whoamiRequest();
      cacheStore.initTrackWithNotes();
      return;
    }

    const expireTime = cusStorage.getItem('loginExpireTime');
    if (expireTime) {
      const now = Date.now();

      if (now > expireTime) {
        handleRoute();
        siteStore.handleLogout();
      }

      return;
    }

    handleRoute();
    siteStore.handleLogout();
  };

  watch(whoamiResponse, () => {
    const [err, res] = whoamiResponse.value;

    if (err) {
      // errorDialog({
      //   desc: err.message,
      // });

      return;
    }

    siteStore.setMemberInfo(res.whoami);
  });

  return {
    handleAuth,
  };
};
